const skin = {
	topLayout:"space",
	//bar in accordion
	barHeight:44,			//!!!Set the same in skin.less!!!
	tabbarHeight: 42,
	sidebarTitleHeight: 44,
	rowHeight:36,
	toolbarHeight:44,
	listItemHeight:36,		//list, grouplist, dataview, etc.
	inputHeight: 38,
	buttonHeight: 38,
	inputPadding: 3,
	menuHeight: 36,
	labelTopHeight: 22,
	propertyItemHeight: 28,
	timelineItemHeight:70,
	unitHeaderHeight:36,

	inputSpacing: 4,
	borderWidth: 1,

	sliderHandleWidth: 14,
	sliderPadding: 10,
	sliderBorder: 1,
	vSliderPadding:15,
	vSliderHeight:100,
	switchHeight:22,
	switchWidth:50,

	//margin - distance between cells
	layoutMargin:{ space:10, wide:10, clean:0, head:4, line:-1, toolbar:4, form:8, accordion: 2  },
	//padding - distance inside cell between cell border and cell content
	layoutPadding:{ space:10, wide:0, clean:0, head:0, line:0, toolbar:2, form:17, accordion: 0  },
	//space between tabs in tabbar
	tabMargin: 0,
	tabOffset: 0,
	tabBottomOffset: 0,
	tabTopOffset:0,
	tabBorder: true,

	customCheckbox: true,
	customRadio: true,
	sidebarMarkAll: true,
	popupNoPoint: true,
	borderlessPopup: true,

	popupPadding: 0,

	dataPadding: 12,

	calendarWeekHeaderHeight: 18,
	padding:0,
	accordionType: "accordion",

	optionHeight: 32,
	timelineColor:"#1CA1C1",

	backColor:"#ffffff",

	//colorboard
	colorPadding: 4
};

export default skin;
